import React, { useEffect } from 'react';
import { IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import FormSelect from 'components/Select/FormSelect';
import style from './AdditionalDishSubCategorySelect.module.scss';

interface IProps {
	setAdditionalDishSubCategory: (value: Nullable<string>) => void;
	selectedAdditionalDishCategory: Nullable<string>;
}

export const AdditionalDishSubCategorySelect: React.FC<IProps> = React.memo(
	({ setAdditionalDishSubCategory, selectedAdditionalDishCategory }) => {
		const { response, loading, refetch, responseError } = useFetchData<
			IGetSubCategoriesShort,
			IGetSubCategoriesArguments
		>(selectedAdditionalDishCategory ? getSubCategoriesShortInfoV2 : null, {
			categoryId: selectedAdditionalDishCategory ? selectedAdditionalDishCategory : '',
		});

		useEffect(() => {
			refetch();
		}, [selectedAdditionalDishCategory]);

		return (
			<FormSelect
				name="selectedAdditionalDishSubCategory"
				label="subcategoryLabel"
				formItemClassName={style.container}
				options={response?.data.subCategories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!selectedAdditionalDishCategory || loading}
				onChange={setAdditionalDishSubCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
